import { render } from "./InvoiceDashboard.vue?vue&type=template&id=39c37eaa"
import script from "./InvoiceDashboard.vue?vue&type=script&lang=js"
export * from "./InvoiceDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__